import rotatingLabel from "@/assets/rotating-label.png";
import vector from "@/assets/vector.png";
import "./common.css";
const RotatingLabel = () => {
  return (
    <>
      <div className="rotating-label-element">
        <img className="rotating-label" src={rotatingLabel} alt="Rotating label animation"></img>
        <img className="vector" src={vector} alt=""></img>
      </div>
    </>
  );
};

export default RotatingLabel;
